var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.latlon && !_vm.checkAgainstSearch())?_c('gmap-marker',{key:_vm.index,ref:"marker",attrs:{"position":_vm.item.latlon,"clickable":true,"draggable":false,"icon":_vm.icon},on:{"click":_vm.handleClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }